const plans = [
  'Medicare Advantage', 'Aetna', 'Blue Cross Blue Shield', 'Cigna',
  'Humana', 'UnitedHealthcare', 'Molina Healthcare', 'Anthem',
  'Medicaid / Nevada Check Up', 'SCAN Health Plan', 'Select Health', 'Tricare',
];

export default function InsuranceSection() {
  return (
    <section className="py-24 bg-white">
      <div className="px-8 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-rose-500"></div>
              <span className="text-rose-500 text-xs font-semibold uppercase tracking-[0.25em]">Insurance</span>
            </div>
            <h2
              className="text-3xl md:text-4xl font-black text-zinc-900 leading-tight mb-5"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              We Accept<br />Most Plans
            </h2>
            <p className="text-zinc-500 text-sm leading-relaxed mb-6">
              We work with most major insurance providers so you can focus on your health, not the paperwork.
            </p>
            <p className="text-zinc-400 text-xs">
              Don't see your plan?{' '}
              <a href="tel:+17025550192" className="text-rose-500 font-semibold hover:underline cursor-pointer">
                Call us
              </a>{' '}
              — we may still be able to help.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {plans.map((plan) => (
                <div
                  key={plan}
                  className="group flex items-center justify-center px-4 py-5 rounded-2xl border border-zinc-100 bg-zinc-50 hover:border-rose-300 hover:bg-rose-50 transition-all duration-200 cursor-default"
                >
                  <span className="text-zinc-600 text-xs font-medium text-center leading-tight group-hover:text-rose-600 transition-colors">
                    {plan}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
